
const CollapseClassNames = {
    Rounded: "mc-collapse-rounded",
    RoundedWithTable: "mc-collapse-rounded mc-collapse-rounded-has-table"
}

export default CollapseClassNames;